exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".collapsible-section {\n  font-weight: 600; }\n  .collapsible-section .title {\n    text-transform: uppercase;\n    margin-bottom: 15px; }\n  .collapsible-section .title .collapse-icon {\n      margin-right: 7.5px; }\n  .collapsible-section .collapse-icon {\n    width: 8px; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/postcss-loader/lib?{"config":{"path":"postcss.config.js"}}!./node_modules/sass-loader/lib/loader.js!./Src/Appointment/AppointmentScheduler/AppointmentForm/CollapsibleSection/CollapsibleSection.scss
// module id = 523
// module chunks = 3